






































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { Upload } from "@/api/pub";
import { AddUser, getUserInfoById } from "@/api/users";
import { Form, Loading } from "element-ui";
import { shipAuth, User } from "@/api/model/user";
import { getBase64 } from "@/util/func";

@Component({
  components: {},
  name: "roleaccount_edit",
})
export default class extends Vue {
  @Prop({})
  private user!: User;
  @Emit("close") private close(refresh:boolean){};
  private checkedItem = <String[]>[];
  //   加载中
  private listLoading = true;
  //   待编辑|新增权限详情
  private form: User = {
    id: 0,
    user_name: "",
    password: "",
    nick_name: "",
    head_img: "",
    role_code: "",
    status: 0,
    add_time: 0,
    role_desc: "",
  };
  private auth = shipAuth;
  created() {
    this.form = JSON.parse(JSON.stringify(this.user));
    var labels = (this.user.labels || "").split(",") || [];
    console.log(this.auth.filter(v=>labels.indexOf(`${v.value}`)!=-1),labels)
    this.checkedItem = this.auth.filter(v=>labels.indexOf(`${v.value}`)!=-1).map(v=>v.label)
  }
  private roleRules = {
    user_name: [
      { required: true, message: "登录账号不能为空", trigger: "blur" },
    ],
    password: [
      {
        validator: this.validatePassword,
        trigger: "blur",
      },
    ],
  };
  validatePassword(rule: any, value: string, callback: Function) {
    if (!this.user.id && (!value||value.length < 6)) {
      callback(new Error("新增用户密码不能为空"));
    } else if (value&&value.length > 0 && value.length < 6) {
      callback(new Error("用户密码为空则为不修改，修改时长度不能小于6位"));
    } else {
      callback();
    }
  }

  private async beforeAvatarUpload(file: any) {
    console.log(file);
    const isJPG = file.raw.type.indexOf("image/") == 0;
    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isJPG) {
      this.$message.error("上传头像只能是图片!");
      return false;
    }
    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 2MB!");
      return false;
    }
    let img = await getBase64(file.raw);
    this.form.head_img = await Upload(img);
  }
  private sub() {
    (this.$refs.role_edit_form as Form).validate((valid: any) => {
      console.log(valid);
      if (valid) {
        let listLoading = Loading.service({});
        var labels = this.auth.filter(v=>this.checkedItem.indexOf(v.label)!=-1).map(v=>v.value).join(",")
        this.form.labels = labels;
        AddUser(this.form)
          .then((res) => {
            this.form = res;
            this.form.password = "";
            this.close(true);
          })
          .finally(() => {
            listLoading.close();
          });
      }
    });
  }
}
